// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3goUJ","noInteraction":"EventWrapper_noInteraction__2kpHP","pointerPassthrough":"EventWrapper_pointerPassthrough__39nWD"};